export const playVideo = ($self) => {
  $self.hide();

  const $parent = $self.parents(".video-wrapper");
  const $video = $parent.find("video");

  $parent.addClass("hide-overlay");
  $video.attr("controls", "controls");
  $video.get(0).play();
};
